module.exports = __webpack_public_path__ + "static/pin-yellow-2720108a9323d730981cceb962158944.png";